import axios from "axios";
import { AxiosData } from "./serviceBasic";

export const insertServiceProvider = (payload) =>
  AxiosData.post("v1/serviceProvider/insert", payload).then((res) => res.data);

export const getAddressByCep = (cep) =>
  axios
    .get(`https://viacep.com.br/ws/${cep}/json/`)
    .then((res) => res.data);

// Mesmo endpoint que o app usa para montar o select de tipo de serviço: são os
// tipos cadastrados pela imobiliária, e não uma lista fixa do cadastro.
export const listServiceTypes = (companyId) =>
  AxiosData.post("v1/ServiceType/listByCompanyId", { companyId }).then((res) => {
    const data = res.data;
    const items = Array.isArray(data)
      ? data
      : (Array.isArray(data?.content) ? data.content : []);

    return items
      .filter((item) => item && item.name)
      .map((item) => ({ id: item.id, name: item.name }));
  });
